export default function MinFridge() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_12938)">
                <path
                    d="M38.25 7.5H9.75C8.50736 7.5 7.5 8.50736 7.5 9.75V36.75C7.5 37.9926 8.50736 39 9.75 39H38.25C39.4926 39 40.5 37.9926 40.5 36.75V9.75C40.5 8.50736 39.4926 7.5 38.25 7.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18 12H7.5V18H15.75C16.9926 18 18 16.9926 18 15.75V12Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M18 39H12V40.5H18V39Z" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36 39H30V40.5H36V39Z" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.5 12H40.5" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_845_12938">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
